import React, { useEffect, useRef } from "react";
import { Animated, Platform, StyleSheet, View } from "react-native";

interface RippleAnimationProps {
    size?: number;
    color?: string;
    duration?: number;
}

export const RippleAnimation: React.FC<RippleAnimationProps> = ({
    size = 200,
    color = "rgba(255, 255, 255, 0.3)",
    duration = 2000,
}) => {
    const animatedValue1 = useRef(new Animated.Value(0)).current;
    const animatedValue2 = useRef(new Animated.Value(0)).current;
    const animatedValue3 = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        const startAnimation = (value: Animated.Value, delay: number) => {
            Animated.sequence([
                Animated.delay(delay),
                Animated.loop(
                    Animated.timing(value, {
                        toValue: 1,
                        duration: duration,
                        useNativeDriver: Platform.OS !== "web",
                    })
                ),
            ]).start();
        };

        startAnimation(animatedValue1, 0);
        startAnimation(animatedValue2, duration / 3);
        startAnimation(animatedValue3, (duration / 3) * 2);

        return () => {
            animatedValue1.stopAnimation();
            animatedValue2.stopAnimation();
            animatedValue3.stopAnimation();
        };
    }, [animatedValue1, animatedValue2, animatedValue3, duration]);

    const getRippleStyle = (value: Animated.Value) => ({
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor: color,
        position: "absolute" as const,
        transform: [
            {
                scale: value.interpolate({
                    inputRange: [0, 1],
                    outputRange: [0, 2],
                }),
            },
        ],
        opacity: value.interpolate({
            inputRange: [0, 0.5, 1],
            outputRange: [0, 0.4, 0],
        }),
    });

    return (
        <View style={[styles.container, { width: size, height: size }]}>
            <Animated.View style={getRippleStyle(animatedValue1)} />
            <Animated.View style={getRippleStyle(animatedValue2)} />
            <Animated.View style={getRippleStyle(animatedValue3)} />
            {/* <View
                style={[
                    styles.dot,
                    {
                        backgroundColor: "#1D9B91",
                        width: 20,
                        height: 20,
                        borderRadius: 10,
                        borderWidth: 3,
                        borderColor: "white",
                    },
                ]}
            /> */}
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
    },
    dot: {
        zIndex: 1,
    },
});
